import { Reducer } from '../../reducers';

interface LogoProps {
  logoPath: string;
}

class Logo extends React.PureComponent<LogoProps> {
  render() {
    const { logoPath } = this.props;

    return (
      <div className="Client-Logo">
        <img src={`${window.Edocat.texts.appContext}${logoPath}`} alt="Client Logo" />
      </div>
    );
  }
}

const mapStateToProps = (state: Reducer) => ({
  logoPath: state.login.logoPath,
});

export default window.reactRedux.connect(mapStateToProps, null)(Logo);
